import { Alert, Box } from "@mui/material";
import { AxiosError } from "axios";

type DatasetViewerAlertsProps = {
  isSourceDataRecordError: boolean;
  sourceDataRecordError: AxiosError | null;
};

const DatasetViewerAlerts = ({
  isSourceDataRecordError,
  sourceDataRecordError,
}: DatasetViewerAlertsProps) => {
  if (!isSourceDataRecordError) {
    return null;
  }

  return (
    <Box>
      <Alert severity="error">{`Error fetching source data records: ${
        (sourceDataRecordError?.response?.data as any)?.detail ||
        "Unknown error"
      }`}</Alert>
    </Box>
  );
};

export default DatasetViewerAlerts;
